export const API_URL = "https://api.bibeet.com"
export const SOCKET_URL = "https://socket.bibeet.com/"

/** Keys stored by auth – only these are cleared on logout */
export const AUTH_STORAGE_KEYS = ["user", "token", "tokentop"];

export const clearAuthStorage = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};
export const PRAGMATIC_URL = "https://cp.bibeet.com"
export const PGSOFT_URL = "https://spgf.bibeet.com"
export const AMATIC_URL = "https://spamatic.bibeet.com"